import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Plus, Edit2, Trash2, Search } from "lucide-react";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

export default function Companies() {
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");
  const [delId, setDelId] = useState(null);

  const load = async () => {
    const { data } = await api.get("/admin/companies", { params: q ? { q } : {} });
    setItems(data);
  };
  useEffect(() => {
    const t = setTimeout(load, 250);
    return () => clearTimeout(t);
    // eslint-disable-next-line
  }, [q]);

  const remove = async () => {
    await api.delete(`/admin/companies/${delId}`);
    toast.success("Silindi");
    setDelId(null);
    load();
  };

  return (
    <div className="space-y-6" data-testid="admin-companies-page">
      <div className="flex items-end justify-between gap-4 flex-wrap">
        <div>
          <span className="label-tag">Bayiler</span>
          <h1 className="font-serif text-4xl mt-2">Firma Yönetimi</h1>
        </div>
        <Link to="/admin/firmalar/yeni" className="btn-luxe text-xs" data-testid="admin-company-new-btn">
          <Plus size={14}/> Yeni Firma
        </Link>
      </div>

      <div className="bg-white border border-[#eae5dc] p-4">
        <div className="relative max-w-md">
          <Search size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#6b655c]" />
          <Input placeholder="Firma adı veya yetkili" value={q} onChange={(e) => setQ(e.target.value)} className="pl-9" data-testid="admin-company-search" />
        </div>
      </div>

      <div className="bg-white border border-[#eae5dc] overflow-x-auto">
        <table className="w-full text-sm min-w-[700px]">
          <thead>
            <tr className="bg-[#f7f5f0] text-xs uppercase tracking-wider text-[#6b655c]">
              <th className="text-left py-3 px-4">Firma</th>
              <th className="text-left py-3 px-4">Yetkili</th>
              <th className="text-left py-3 px-4">Telefon</th>
              <th className="text-left py-3 px-4">Şehir</th>
              <th className="text-left py-3 px-4">Kullanıcı</th>
              <th className="text-center py-3 px-4">Durum</th>
              <th className="text-right py-3 px-4">İşlem</th>
            </tr>
          </thead>
          <tbody>
            {items.length === 0 && <tr><td colSpan={7} className="py-12 text-center text-[#6b655c]">Firma yok</td></tr>}
            {items.map((c) => (
              <tr key={c.id} className="border-t border-[#f0ebe2]">
                <td className="py-3 px-4">
                  <div className="font-medium">{c.short_name}</div>
                  <div className="text-xs text-[#6b655c]">{c.title}</div>
                </td>
                <td className="py-3 px-4">{c.contact_person}</td>
                <td className="py-3 px-4 font-mono text-xs">{c.phone}</td>
                <td className="py-3 px-4">{c.city}</td>
                <td className="py-3 px-4 font-mono text-xs">{c.username || "—"}</td>
                <td className="py-3 px-4 text-center">
                  <span className={`text-[0.65rem] uppercase tracking-wider px-2 py-1 ${c.active ? "bg-emerald-50 text-emerald-800" : "bg-stone-100 text-stone-700"}`}>
                    {c.active ? "Aktif" : "Pasif"}
                  </span>
                </td>
                <td className="py-3 px-4 text-right">
                  <div className="inline-flex gap-1">
                    <Link to={`/admin/firmalar/${c.id}`} className="p-2 hover:bg-[#f7f5f0]" data-testid={`company-edit-${c.id}`}><Edit2 size={14}/></Link>
                    <button onClick={() => setDelId(c.id)} className="p-2 hover:bg-red-50 text-red-600"><Trash2 size={14}/></button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <AlertDialog open={!!delId} onOpenChange={(o) => !o && setDelId(null)}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Firmayı sil?</AlertDialogTitle>
            <AlertDialogDescription>Firma ve bayi kullanıcısı kalıcı olarak silinir.</AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel>Vazgeç</AlertDialogCancel>
            <AlertDialogAction onClick={remove}>Sil</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </div>
  );
}
